import variables from '@/assets/scss/exports.scss'
import { dateFormatter } from '@/helpers/dateFormatter'
import {
  getRoadmapEventStatusesColorByRole,
  getRoadmapEventStatusesLabelByRole,
} from '@/typings/api/RoadmapEvent'
import {
  ReportDataCommonRowType as RowType,
  ReportDataCommonRow as Row,
} from '@/typings/api/Report'


const DATE_FORMAT = 'DD.MM.YYYY'

export const TABLE_HEADERS = Object.freeze([
  {
    text: '№',
    value: 'number',
    sortable: false,
    width: 40,
  },
  {
    text: 'Направление дорожной карты',
    value: 'name',
    sortable: false,
    field: (name: Row['name'], data: Row) => (
      data.type === RowType.direction
        ? `<b>${name}</b>` : name
    ),
  },
  {
    text: 'Дата',
    value: 'end_at',
    sortable: false,
    width: 70,
    field: (value: Row['end_at']) => (
      value && dateFormatter(value, DATE_FORMAT)
    ),
  },
  {
    text: 'Результат',
    value: 'status',
    width: 100,
    sortable: false,
    field: (status: Row['status']) => status && ({
      label: getRoadmapEventStatusesLabelByRole(status, true, false),
      color: getRoadmapEventStatusesColorByRole(status, true, false),
    }),
  },
  {
    text: 'Загруженные файлы',
    value: 'files',
    width: 240,
    sortable: false,
  },
  {
    text: 'Отметка о подтверждении',
    value: 'is_confirmed',
    sortable: false,
    width: 120,
    field: (isConfirmed: Row['is_confirmed']) => (
      isConfirmed
        ? {
          label: 'Подтверждено',
          color: variables['webflow-color-green'],
        }
        : {
          label: 'Не подтверждено',
          color: variables['webflow-color-red'],
        }
    ),
  },
])
